import { useContext } from 'react';

import { Button } from 'components/rebrand/Button';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';
import { LocaleContext } from 'components/rebrand/Layout';
import { H4 } from 'components/rebrand/Typography';

import { getAfTracking, trackEventUniversal } from 'helpers';

const Banner = ({
  node,
}: {
  node: { af_adset: string | null; af_adset_id: string; text: string | null; title: string } | null;
}) => {
  const locale = useContext(LocaleContext);

  if (!node || !node.title) return null;

  const trackingParams = node.af_adset
    ? { hash: {}, search: { af_channel: 'BLOGS', af_adset: node.af_adset, af_adset_id: node.af_adset_id } }
    : getAfTracking(node.af_adset_id);

  return (
    <GetKOHOBtn
      className="mb-30 mt-20 block w-full rounded-16 bg-primary-500 p-32 xs:mb-40 xs:mt-30 md:mb-50 md:mt-40"
      buttonVariant="text"
      buttonClassName="text-primary-100 flex flex-col md:flex-row md:items-center justify-between gap-16 w-full"
      buttonLocation="blog banner"
      queryParams={trackingParams}
      trackEventProps={{
        category: 'blog',
        label: 'Blog',
        locale,
        location: node.title,
      }}
      onClick={() =>
        trackEventUniversal('Blog banner clicked', {
          event_label: `Blog ${node.title}`,
          event_category: 'Blog Banners',
        })
      }
    >
      <H4 className="text-left text-4xl uppercase md:text-4xl">
        {node.text ?? { en: 'SPEND SMARTER. SAVE FASTER', fr: 'DÉPENSEZ MIEUX. ÉCONOMISEZ PLUS' }[locale]}
      </H4>
      <Button className="w-fit whitespace-nowrap">{{ en: 'Open Account', fr: 'Ouvrir un compte' }[locale]}</Button>
    </GetKOHOBtn>
  );
};

export default Banner;
